import { makeMultiSearch, makeSearch } from "../../UI/Search/Search";
import StateService from "../../../Services/State.service";
const config = {
    loadOptions: (search, options) => StateService.search({ names: [search] }, { max: 65 }).then(({ data }) => data),
    value: "id",
    label: "name",
};
export const StateSearch = makeSearch(config);
export const StateMultiSearch = makeMultiSearch(config);
